export interface Hierarchy {
  id: number,
  parent_id: number,
  children?: Array<Hierarchy>
}

export interface Category extends Hierarchy {
  title: String,
  created_at: Date,
  updated_at: Date,
  description?: String,
  measure_id: null|number,
  type_category_id: null|number,
}

export class Categories {
  protected categories: Array<Hierarchy> = [];

  constructor (categories: Array<Hierarchy> = []) {
    this.categories = categories;
  }

  public getHierarchy (id:number|null, structure: Array<Hierarchy> = []) :Array<Hierarchy> {
    if (id === null) {
      return [];
    }
    const categories = [...this.categories];
    for (let i = 0; i < categories.length; i++) {
      if (id === categories[i].id) {
        structure.push(categories[i]);
        if (categories[i].parent_id) {
          this.getHierarchy(categories[i].parent_id, structure);
        } else {
          return structure.reverse();
        }
      }
    }
    return structure;
  }
  public getChildren (id:number) {
    const categories = [...this.categories];
    let children: Array<Hierarchy> = [];
    for (let i = 0; i < categories.length; i++) {
      if (id === categories[i].parent_id) {
        children.push(categories[i]);
        children[children.length - 1].children =
          this.getChildren(children[children.length - 1].id);
      }
    }
    return children;
  }
  public getParent () {
    const categories = [...this.categories];
    let data: Array<Hierarchy> = [];
    for (let i = 0; i < categories.length; i++) {
      if (!categories[i].parent_id) {
        this.categories.splice(i, 1);
        data.push(categories[i]);
      }
    }
    return data;
  }

  public getStructured (data?: Array<Hierarchy>) {
    if (!data) {
      data = this.getParent();
    }
    for (let i = 0; i < data.length; i++) {
      data[i].children = this.getChildren(data[i].id);
    }
    return data;
  }
}
